







import { Component, Mixins } from 'vue-property-decorator';
import FaqMain from '@/components/faq/FaqMain/index.vue';
import FaqSearch from '@/components/faq/FaqSearch/index.vue';
import FaqMixin from '@/mixins/faq';
import store from '@/store';
import { removeLoader } from '@/utils';

@Component({
  components: {
    FaqMain,
    FaqSearch
  }
})
export default class FaqHomeView extends Mixins(FaqMixin) {
  async beforeRouteEnter(to, from, next) {
    store.dispatch('fetchQueriedArticles', {
      label_names: 'promoted'
    });
    if (!store.getters['isInitialLoaded']('faq')) {
      try {
        await store.dispatch('fetchCategories');
      } finally {
        store.dispatch('setInitialLoading', 'faq');
        removeLoader();
        next();
      }
    } else {
      next();
    }
  }
  beforeRouteLeave(to, from, next) {
    store.dispatch('resetPage');
    next();
  }
}
